module.exports = __webpack_public_path__ + "img/ic-arrow-left.d1d9ed45.svg";